import React from 'react'
import styled from 'styled-components'
import { DocumentTitle } from 'shared'

const Wrapper = styled.div`
  padding: 20px 40px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;

  .home-logo,
  .about-logo {
    width: 200px;
  }
`

const Home = () => (
  <>
    <DocumentTitle title="Loankeeper" />
    <Wrapper>
      <img className="home-logo" src="/static/img/test_logo.png" alt="logo" />
      <img className="about-logo" src="/static/img/about_logo.png" alt="about logo" />
    </Wrapper>
  </>
)

export default Home
